// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__9uavZ","active":"breadcrumb_active__3vqYL"};